<div class="d-flex align-items-center">
  <sb-icon style="font-size: 2rem" *ngIf="deviceService.icon(device)" class="mr-1" [icon]="deviceService.icon(device)"
           [ngClass]="deviceService.iconColor(device)"></sb-icon>
  <div class="ml-3">
    <div class="cursor-help" container="body" [ngbTooltip]="deviceService.iconTooltip(device)"
         [placement]="tooltipPlacement ? tooltipPlacement : 'right'">
      <span [ngClass]="deviceService.iconColor(device)">{{deviceService.iconText(device)}}</span>
      <span *ngIf="device?.serviceRequest" [ngClass]="deviceService.iconColor(device)">&nbsp;Service!</span>
    </div>
    <span [ngClass]="color" container="body" [ngbTooltip]="tooltip"
          [placement]="tooltipPlacement ? tooltipPlacement : 'right'"
          class="cursor-help">{{text}}
    </span>
  </div>
</div>

